import styled from "styled-components";
import { ArrowLeftIcon, theme } from "ui";

export const RootContainer = styled.div`
  display: flex;
  max-width: 588px;
  min-width: ${theme.space.x90};
  flex-direction: column;
  gap: ${theme.space.x6};

  @media ${theme.device.mobileFirst.tablet} {
    width: 530px !important;
  }

  @media ${theme.device.mobileFirst.tabletS} {
    width: 400px;
  }
`;

export const CreditCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.space.x4};
`;

export const SubTitle = styled.h2`
  font-size: ${theme.typography.fontSize.sm.x3};
  font-weight: ${theme.typography.fontWeight["400"]};
`;

export const MobileContainer = styled.div``;

export const BackButton = styled.button`
  background-color: transparent;
  display: flex;
  align-items: center;
  border: none;
  padding-bottom: ${theme.space.x3};
  font-size: ${theme.typography.fontSize.sm.x5};
  color: ${theme.colors.neutral["550"]};
  gap: ${theme.space.x1};
  cursor: pointer;
`;

export const BackIcon = styled(ArrowLeftIcon)``;
